import React from 'react'
import Select from 'react-select'
import './index.scss';
import { i18nLabels } from '../../../../../constants/constants';
import { useTranslation } from 'react-i18next';

export default function DisplayLanguage(props) {
  const { label } = props;

  const {i18n} = useTranslation(['teacher_parent_report'])

  const handleChange = (option) => {
    i18n.changeLanguage(option.value)
  }

  const options = Object.keys(i18nLabels).map(value => ({value, label: i18nLabels[value]}))

  const getValue = () => {
    let currentValue = i18n?.language;
    if (currentValue === 'en') currentValue = 'en-us';
    return options.find(option => option.value === currentValue);
  }

  return (
    <div className='display-language-select-container'>
      <div className='display-language-select-label'>{label}</div>
      <div className='display-language-select'>
        <Select
          classNamePrefix='teacherSecondarySelect'
          value={getValue()}
          onChange={handleChange}
          options={options}
        />
      </div>
    </div>
  )
}